(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const titleFooter = document.querySelectorAll('.footer__title');

  if (titleFooter.length > 0) {
    titleFooter.forEach(function (item) {
      item.addEventListener('click', function () {
        // change svg
        if (this.querySelector('svg').classList.contains('rotate-svg')) {
          this.querySelector('svg').classList.remove('rotate-svg');
        } else {
          this.querySelector('svg').classList.add('rotate-svg');
        }
        // open close content
        let subMenuFooter = item.parentNode.querySelector('.sub-menu-footer');
        if (subMenuFooter.style.maxHeight) {
          subMenuFooter.style.maxHeight = null;
        } else {
          subMenuFooter.style.maxHeight = subMenuFooter.scrollHeight + 'px';
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-design-1"] && !Shopify.designMode) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            (this.header = document.getElementById("shopify-section-header")),
                (this.headerBounds = {}),
                (this.currentScrollTop = 0),
                (this.preventReveal = !1),
                (this.predictiveSearch = this.querySelector("predictive-search")),
                (this.onScrollHandler = this.onScroll.bind(this)),
                (this.hideHeaderOnScrollUp = () => (this.preventReveal = !0)),
                this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp),
                window.addEventListener("scroll", this.onScrollHandler, !1),
                this.createObserver();
        }
        disconnectedCallback() {
            this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp), window.removeEventListener("scroll", this.onScrollHandler);
        }
        createObserver() {
            new IntersectionObserver((e, t) => {
                (this.headerBounds = e[0].intersectionRect), t.disconnect();
            }).observe(this.header);
        }
        onScroll() {
            let e = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.predictiveSearch || !this.predictiveSearch.isOpen) {
                if (e > this.currentScrollTop && e > this.headerBounds.bottom) {
                    if (this.preventHide) return;
                    requestAnimationFrame(this.hide.bind(this));
                } else
                    e < this.currentScrollTop && e > this.headerBounds.bottom
                        ? this.preventReveal
                            ? (window.clearTimeout(this.isScrolling),
                                (this.isScrolling = setTimeout(() => {
                                    this.preventReveal = !1;
                                }, 66)),
                                requestAnimationFrame(this.hide.bind(this)))
                            : requestAnimationFrame(this.reveal.bind(this))
                        : e <= this.headerBounds.top && requestAnimationFrame(this.reset.bind(this));
                this.currentScrollTop = e;
            }
        }
        hide() {
            this.header.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky", "sticky", "top-0", "z-[99]");
        }
        reveal() {
            this.header.classList.add("shopify-section-header-sticky", "animate"), this.header.classList.remove("shopify-section-header-hidden");
        }
        reset() {
            this.header.classList.remove("shopify-section-header-hidden", "shopify-section-header-sticky", "animate");
        }
    }
    customElements.define("sticky-header", StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-design-2"] && !Shopify.designMode) return;
  try {
    
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        (this.header = document.getElementById("shopify-section-header-design-2")),
        this.header_ds2__bottom = this.querySelector('.header-ds2__bottom'),
        (this.headerBounds = {}),
        (this.currentScrollTop = 0),
        (this.preventReveal = !1),
        (this.predictiveSearch = this.querySelector("predictive-search")),
        (this.onScrollHandler = this.onScroll.bind(this)),
        (this.hideHeaderOnScrollUp = () => (this.preventReveal = !0)),
        this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp),
        window.addEventListener("scroll", this.onScrollHandler, !1),
        this.createObserver();
        console.log(this.header_ds2__bottom);
      }
      disconnectedCallback() {
        this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp), window.removeEventListener("scroll", this.onScrollHandler);
      }
      createObserver() {
        new IntersectionObserver((e, t) => {
          (this.headerBounds = e[0].intersectionRect), t.disconnect();
        }).observe(this.header);
      }
      onScroll() {
        let e = window.pageYOffset || document.documentElement.scrollTop;
        if (!this.predictiveSearch || !this.predictiveSearch.isOpen) {
          if (e > this.currentScrollTop && e > this.headerBounds.bottom) {
            if (this.preventHide) return;
            requestAnimationFrame(this.hide.bind(this));
          } else
            e < this.currentScrollTop && e > this.headerBounds.bottom
                    ? this.preventReveal
                            ? (window.clearTimeout(this.isScrolling),
                                    (this.isScrolling = setTimeout(() => {
                                      this.preventReveal = !1;
                                    }, 66)),
                                    requestAnimationFrame(this.hide.bind(this)))
                            : requestAnimationFrame(this.reveal.bind(this))
                    : e <= this.headerBounds.top && requestAnimationFrame(this.reset.bind(this));
          this.currentScrollTop = e;
        }
      }
      hide() {
        this.header.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky", "sticky", "top-0", "z-[99]");
        this.header_ds2__bottom.classList.add('hidden')
      }
      reveal() {
        this.header.classList.add("shopify-section-header-sticky", "animate"), this.header.classList.remove("shopify-section-header-hidden");
        this.header_ds2__bottom.classList.add('hidden')
      }
      reset() {
        this.header.classList.remove("shopify-section-header-hidden", "shopify-section-header-sticky", "animate");
        this.header_ds2__bottom.classList.remove('hidden')
      }
    }
    customElements.define("sticky-header", StickyHeader);
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.header = document.getElementById("shopify-section-header")),
              (this.headerBounds = {}),
              (this.currentScrollTop = 0),
              (this.preventReveal = !1),
              (this.predictiveSearch = this.querySelector("predictive-search")),
              (this.onScrollHandler = this.onScroll.bind(this)),
              (this.hideHeaderOnScrollUp = () => (this.preventReveal = !0)),
              this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp),
              window.addEventListener("scroll", this.onScrollHandler, !1),
              this.createObserver();
    }
    disconnectedCallback() {
      this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp), window.removeEventListener("scroll", this.onScrollHandler);
    }
    createObserver() {
      new IntersectionObserver((e, t) => {
        (this.headerBounds = e[0].intersectionRect), t.disconnect();
      }).observe(this.header);
    }
    onScroll() {
      let e = window.pageYOffset || document.documentElement.scrollTop;
      if (!this.predictiveSearch || !this.predictiveSearch.isOpen) {
        if (e > this.currentScrollTop && e > this.headerBounds.bottom) {
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else
          e < this.currentScrollTop && e > this.headerBounds.bottom
                  ? this.preventReveal
                          ? (window.clearTimeout(this.isScrolling),
                                  (this.isScrolling = setTimeout(() => {
                                    this.preventReveal = !1;
                                  }, 66)),
                                  requestAnimationFrame(this.hide.bind(this)))
                          : requestAnimationFrame(this.reveal.bind(this))
                  : e <= this.headerBounds.top && requestAnimationFrame(this.reset.bind(this));
        this.currentScrollTop = e;
      }
    }
    hide() {
      this.header.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky", "sticky", "top-0", "z-[99]");
    }
    reveal() {
      this.header.classList.add("shopify-section-header-sticky", "animate"), this.header.classList.remove("shopify-section-header-hidden");
    }
    reset() {
      this.header.classList.remove("shopify-section-header-hidden", "shopify-section-header-sticky", "animate");
    }
  }
  customElements.define("sticky-header", StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }

            if (window.innerWidth <= 768) {
              const wpItemMain = document.querySelector('.product-rize-mobile');
              if (wpItemMain) {
                wpItemMain.classList.add('swiper');
                let swiperWrapper = wpItemMain.firstElementChild;
                swiperWrapper.classList.add('swiper-wrapper');
                const swiperaItem = wpItemMain.querySelectorAll('.grid__item');
                swiperaItem.forEach(function (itemSlide) {
                  itemSlide.classList.add('swiper-slide');
                });
                var mobileSliderRecomend = new Swiper(wpItemMain, {
                  slidesPerView: 1.6,
                  loop: false,
                  spaceBetween: 20,
                  breakpoints: {
                    600: {
                      slidesPerView: 2.5,
                    },
                  },
                });
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
